<div class="hero">
  <div class="hero-overlay"></div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h2 class="fw-bold">Microchip database finder</h2>
        <h6>
          identibase and Purina are working together to help keepers find out which microchip database stores their pet’s details and whether they are up to date. 
        </h6>
      </div>
    </div>
  </div>
</div>

<div class="content-container">
  <div class="container pt-4">
    <h2 class="text-center">Checking your pet’s microchip</h2>
    <h5>
      We've been helping pet keepers keep their pets safe and sound since 1989. 
      Knowing which microchip database stores your pet's details is important in case you need to contact the database about your pet.
    </h5>
  </div>
  <div class="check-container container pt-3">
    <div class="row">
      <div class="col-12 col-md-6 d-flex flex-column">
        <app-chip-checker class="mb-3" [variant]="'purina'"></app-chip-checker>
      </div>
      <div class="col-12 col-md-6">
        <h4>Why check your pet’s microchip?</h4>
        <ul class="list-content">
          <li>A microchip is the best way to help reunite you with your pet</li>
          <li>A microchip is only as good as the data stored on it</li>
          <li>Keepers risk a £500 fine if their information is out of date</li>
          <li>Knowing your pet’s database saves time if your pet gets lost or stolen</li>
        </ul>
      </div>
    </div>
  </div>
  <div class="next-check-container pb-4">
    <div class="check-container container mt-4">
      <h2 class="mb-5 mt-4">Next Steps</h2>
      <p class="h5">
        Depending on where your pet is registered or if they aren't registered, here's how you can
        reach your pet's microchip record:
      </p>
      <div class="cards-container mx-3 mb-3">
        <app-next-step-card
          *ngFor="let cardProps of nextStepCards"
          class="card"
          [title]="cardProps.title"
          [text]="cardProps.text"
          [secondaryText]="cardProps.secondaryText"
          [link]="cardProps.link"
          [linkRedirect]="cardProps.linkRedirect"
          [button]="cardProps.button"
          [variant]="'next-purina'"
        ></app-next-step-card>
      </div>
    </div>
  </div>

  <div class="check-container container mt-4">
    <h2 class="mb-5">Useful links</h2>

    <div class="cards-container mx-3 mb-3">
      <app-next-step-card
        *ngFor="let cardProps of usefulLinkCards"
        class="useful-card"
        [style.background-image]="'url(' + cardProps.img + ')'"
        [style.background-size]="cardProps.background"
        [link]="cardProps.link"
        [linkRedirect]="cardProps.linkRedirect"
        [variant]="'useful'"
      ></app-next-step-card>
    </div>
  </div>
</div>
